import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XCircleIcon,
} from "@heroicons/react/20/solid";

import { cn } from "@/helpers/className";

interface AlertProps {
  className?: string;
  message: string;
  title?: string;
  type: "positive" | "negative" | "warning" | "info";
}

export const Alert = ({ type, title, message, className }: AlertProps) => {
  const typeMap = {
    positive: {
      color: "green", // use classes: bg-green-50, text-green-400, text-green-700, text-green-800
      icon: CheckCircleIcon,
    },
    negative: {
      color: "red", // use classes: bg-red-50, text-red-400, text-red-700, text-red-800
      icon: XCircleIcon,
    },
    warning: {
      color: "yellow", // use classes: bg-yellow-50, text-yellow-400, text-yellow-700, text-yellow-800
      icon: ExclamationTriangleIcon,
    },
    info: {
      color: "blue", // use classes: bg-blue-50, text-blue-400, text-blue-700, text-blue-800
      icon: InformationCircleIcon,
    },
  };

  const color = typeMap[type]?.color ?? "blue";
  const Icon = typeMap[type]?.icon ?? InformationCircleIcon;

  return (
    <div className={cn(`rounded-xl bg-${color}-50 p-4 shadow-md`, className)}>
      <div className="flex">
        <div className="flex-shrink-0">
          <Icon className={`h-5 w-5 text-${color}-400`} aria-hidden="true" />
        </div>
        <div className="ml-3">
          {title && (
            <div className={`text-sm font-medium text-${color}-800`}>
              {title}
            </div>
          )}

          {message && (
            <div className={cn(`text-sm text-${color}-700`, title && "mt-2")}>
              <div dangerouslySetInnerHTML={{ __html: message }}></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
